import React, { useCallback } from 'react'
import { useContextSelector } from 'use-context-selector'

import { FormContext } from 'components/formKit/Form'
import type { SubmitResultType } from 'components/formKit/types'
import Button from 'components/uiKit/Button'
import type { IButtonPropsType } from 'components/uiKit/Button/Button'
import { t } from 'services/Translation'

interface IFormButtonSubmitProps extends Omit<IButtonPropsType, 'children' | 'onClick'> {
  label?: React.ReactNode
  resettable?: boolean
  onClick?: (result: unknown) => SubmitResultType<unknown>
}

const FormButtonSubmit = ({
  loading,
  disabled,
  resettable,
  onClick,
  label = t('uiKit.button.save'),
  ...rest
}: IFormButtonSubmitProps) => {
  const submit = useContextSelector(FormContext, (state) => state.submit)
  const resetFields = useContextSelector(FormContext, (state) => state.resetFields)
  const submitting = useContextSelector(FormContext, (state) => state.submitting)
  const valid = useContextSelector(FormContext, (state) => state.isValid)

  const handleClick = useCallback(
    async (e: React.MouseEvent | React.KeyboardEvent<HTMLButtonElement>) => {
      e.preventDefault()
      if (disabled) {
        return
      }

      const a = await submit?.()
      onClick?.(a)
      if (resettable) {
        resetFields()
      }
    },
    [onClick, submit, resetFields, resettable, disabled],
  )

  return (
    <Button
      {...rest}
      disabled={!valid || disabled}
      loading={loading || submitting}
      onClick={handleClick}
    >
      {label}
    </Button>
  )
}

export default FormButtonSubmit
